import React from 'react';
import PropTypes from 'prop-types';
import { Autocomplete, TextField } from '@mui/material';
import { useField, useFormikContext } from 'formik';

const AutocompleteField = (props) => {
  const {
    name,
    label,
    options,
    placeholder,
    getOptionLabel: customGetOptionLabel,
    required,
    requiredHintText = 'This field is required',
    onSelectionChange,
    ...selectProps
  } = props;
  const [field, meta] = useField(name);
  const { value: selectedValue } = field;
  const { setFieldValue } = useFormikContext();

  const selectedId = selectedValue && typeof selectedValue === 'object'
    ? selectedValue.id
    : selectedValue;

  const isValueEmpty = (value) => {
    if (Array.isArray(value)) {
      return value.length === 0;
    }
    if (value == null) {
      return true;
    }
    if (typeof value === 'string') {
      return value.trim() === '';
    }
    return false;
  };

  const renderHelperText = () => {
    if (meta.touched && meta.error) {
      return meta.error;
    }
    if (required && isValueEmpty(selectedValue)) {
      return requiredHintText;
    }
    return null;
  };

  const handleInputChange = (_, newValue) => {
    const fieldValue = newValue?.id || '';
    setFieldValue(name, fieldValue);
    onSelectionChange?.(newValue);
  };

  const autoCompletedValue = () => {
    if (!selectedId) return null;
    return options.find((option) => option.id === selectedId)
      || (typeof selectedValue === 'object' ? selectedValue : null);
  };

  return (
    <Autocomplete
      {...selectProps}
      options={options || []}
      onChange={handleInputChange}
      value={autoCompletedValue()}
      getOptionLabel={customGetOptionLabel || ((option) => (
        option?.name
        || option?.label
        || option?.registration_num
        || option?.uid
        || ''
      ))}
      isOptionEqualToValue={(option, value) => option?.id === value?.id}
      renderInput={(inputProps) => (
        <TextField
          {...inputProps}
          label={label}
          placeholder={placeholder}
          error={Boolean(meta.touched && meta.error)}
          helperText={renderHelperText()}
        />
      )}
    />
  );
};

AutocompleteField.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  options: PropTypes.array,
  placeholder: PropTypes.string,
  getOptionLabel: PropTypes.func,
  required: PropTypes.bool,
  requiredHintText: PropTypes.string,
  onSelectionChange: PropTypes.func
};

export default AutocompleteField;
